import React from "react";
import classNames from "classnames";

const Toggle = ({ checked, onChange, size = "large", ariaLabel = "Toggle", isDisabled }) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      onClick={() => !isDisabled && onChange(!checked)}
      disabled={isDisabled}
      className={classNames(
        "relative flex items-center transition-colors duration-300 ease-in-out",
        "focus:outline-none",
        size === "large" ? "w-23 h-12" : "w-[54px] h-[30px]",
        {
          "bg-blue-500": !isDisabled && checked,
          "bg-gray-300": !isDisabled && !checked,
          "bg-gray-200 cursor-not-allowed": isDisabled,
        },
        "rounded-full"
      )}
    >
      {/* Toggle Knob */}
      <span
        className={classNames(
          "absolute bg-white rounded-full shadow-md transform transition-transform duration-300 ease-in-out",
          size === "large" ? "w-10 h-10 left-1" : "w-6 h-6 left-1",
          checked ? (size === "large" ? "translate-x-10" : "translate-x-5") : "translate-x-0"
        )}
      />
    </button>
  );
};

export default Toggle;
